
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.125 4H2.875C1.839 4 1 4.84 1 5.875v11.25C1 18.161 1.84 19 2.875 19h16.25C20.161 19 21 18.16 21 17.125V5.875C21 4.839 20.16 4 19.125 4zM11 15.172a.703.703 0 01-.703.703H4.203a.703.703 0 01-.703-.703v-.543c0-.645.44-1.208 1.065-1.364l1.045-.261c.852.613 2.183.79 3.28 0l1.045.261A1.406 1.406 0 0111 14.629v.543zm-6.094-4.453a2.344 2.344 0 114.688 0 2.344 2.344 0 01-4.688 0zM18.5 14.78c0 .26-.21.469-.469.469H12.72a.469.469 0 01-.469-.469v-.312c0-.26.21-.469.469-.469h5.312c.26 0 .469.21.469.469v.312zm0-2.5c0 .26-.21.469-.469.469H12.72a.469.469 0 01-.469-.469v-.312c0-.26.21-.469.469-.469h5.312c.26 0 .469.21.469.469v.312zm0-2.5c0 .26-.21.469-.469.469H12.72a.469.469 0 01-.469-.469V9.47c0-.26.21-.469.469-.469h5.312c.26 0 .469.21.469.469v.312zm1.25-3.75c0 .26-.21.469-.469.469H2.72a.469.469 0 01-.469-.469V5.72c0-.26.21-.469.469-.469H19.28c.26 0 .469.21.469.469v.312z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_menu_tomador.svg